<template>
  <div class="tag">
    <div class="tag-name">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.75 5.625C9.75 5.8475 9.68402 6.06501 9.5604 6.25002C9.43679 6.43502 9.26109 6.57922 9.05552 6.66437C8.84995 6.74951 8.62375 6.77179 8.40552 6.72838C8.1873 6.68498 7.98684 6.57783 7.82951 6.4205C7.67217 6.26316 7.56503 6.06271 7.52162 5.84448C7.47821 5.62625 7.50049 5.40005 7.58564 5.19448C7.67078 4.98891 7.81498 4.81321 7.99998 4.6896C8.18499 4.56598 8.4025 4.5 8.625 4.5C8.92337 4.5 9.20952 4.61853 9.4205 4.82951C9.63147 5.04048 9.75 5.32663 9.75 5.625ZM15.375 6.75C15.5975 6.75 15.815 6.68402 16 6.5604C16.185 6.43679 16.3292 6.26109 16.4144 6.05552C16.4995 5.84995 16.5218 5.62375 16.4784 5.40552C16.435 5.1873 16.3278 4.98684 16.1705 4.82951C16.0132 4.67217 15.8127 4.56503 15.5945 4.52162C15.3762 4.47821 15.15 4.50049 14.9445 4.58564C14.7389 4.67078 14.5632 4.81498 14.4396 4.99998C14.316 5.18499 14.25 5.4025 14.25 5.625C14.25 5.92337 14.3685 6.20952 14.5795 6.4205C14.7905 6.63147 15.0766 6.75 15.375 6.75ZM8.625 10.875C8.4025 10.875 8.18499 10.941 7.99998 11.0646C7.81498 11.1882 7.67078 11.3639 7.58564 11.5695C7.50049 11.775 7.47821 12.0012 7.52162 12.2195C7.56503 12.4377 7.67217 12.6382 7.82951 12.7955C7.98684 12.9528 8.1873 13.06 8.40552 13.1034C8.62375 13.1468 8.84995 13.1245 9.05552 13.0394C9.26109 12.9542 9.43679 12.81 9.5604 12.625C9.68402 12.44 9.75 12.2225 9.75 12C9.75 11.7016 9.63147 11.4155 9.4205 11.2045C9.20952 10.9935 8.92337 10.875 8.625 10.875ZM15.375 10.875C15.1525 10.875 14.935 10.941 14.75 11.0646C14.565 11.1882 14.4208 11.3639 14.3356 11.5695C14.2505 11.775 14.2282 12.0012 14.2716 12.2195C14.315 12.4377 14.4222 12.6382 14.5795 12.7955C14.7368 12.9528 14.9373 13.06 15.1555 13.1034C15.3738 13.1468 15.6 13.1245 15.8055 13.0394C16.0111 12.9542 16.1868 12.81 16.3104 12.625C16.434 12.44 16.5 12.2225 16.5 12C16.5 11.7016 16.3815 11.4155 16.1705 11.2045C15.9595 10.9935 15.6734 10.875 15.375 10.875ZM8.625 17.25C8.4025 17.25 8.18499 17.316 7.99998 17.4396C7.81498 17.5632 7.67078 17.7389 7.58564 17.9445C7.50049 18.15 7.47821 18.3762 7.52162 18.5945C7.56503 18.8127 7.67217 19.0132 7.82951 19.1705C7.98684 19.3278 8.1873 19.435 8.40552 19.4784C8.62375 19.5218 8.84995 19.4995 9.05552 19.4144C9.26109 19.3292 9.43679 19.185 9.5604 19C9.68402 18.815 9.75 18.5975 9.75 18.375C9.75 18.0766 9.63147 17.7905 9.4205 17.5795C9.20952 17.3685 8.92337 17.25 8.625 17.25ZM15.375 17.25C15.1525 17.25 14.935 17.316 14.75 17.4396C14.565 17.5632 14.4208 17.7389 14.3356 17.9445C14.2505 18.15 14.2282 18.3762 14.2716 18.5945C14.315 18.8127 14.4222 19.0132 14.5795 19.1705C14.7368 19.3278 14.9373 19.435 15.1555 19.4784C15.3738 19.5218 15.6 19.4995 15.8055 19.4144C16.0111 19.3292 16.1868 19.185 16.3104 19C16.434 18.815 16.5 18.5975 16.5 18.375C16.5 18.0766 16.3815 17.7905 16.1705 17.5795C15.9595 17.3685 15.6734 17.25 15.375 17.25Z"
          fill="#8692A6"
        />
      </svg>
      <div class="check">
        <CustomCheckbox :id="tag.id" :input-element="tag" />
      </div>
      <span>{{ tag.tag }}</span>
    </div>
    <div
      :id="`user_${tag.tag + tag.orderIndex}`"
      class="holder-info name"
    >
      <div v-if="tag.user" class="name-wrapper">
        <div class="img">
          <img
            v-if="tag.user.avatar"
            :src="tag.user.avatar"
            onerror="this.src='https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png';"
            alt=""
          >
          <img
            v-else
            src="https://cdn4.iconfinder.com/data/icons/avatars-xmas-giveaway/128/girl_female_woman_avatar-512.png"
            alt=""
          >
        </div>
        <div v-if="tag.user.firstName && tag.user.lastName" class="info">
          <span
            class="info-name"
          >{{
            capitalizeFirstLetter(tag.user.firstName)
          }} {{ capitalizeFirstLetter(tag.user.lastName) }}</span>
        </div>
        <div v-else class="info">
          <span class="info-name">{{ tag.user.email }}</span>
        </div>
      </div>
      <div v-else class="no-name" />
      <ContextMenu
        v-if="!isDefault"
        tag-menu
        :item="tag"
        @delete="$emit('delete', tag)"
        @inputValue="changeTagName"
      />
    </div>
  </div>
</template>

<script>
import ContextMenu from '@/components/popups/ContextMenu.vue';
import CustomCheckbox from '@/components/inputs/CustomCheckbox.vue';
import capitalizeFirstLetter from '@/mixins/capitalizeFirstLetter';

export default {
  name: 'MessagesTagItem',
  components: {
    CustomCheckbox,
    ContextMenu,
  },
  emits: ['changeTag'],
  mixins: [capitalizeFirstLetter],
  props: {
    tag: {
      type: Object,
      required: true,
    },
    isDefault: {
      type: Boolean,
      required: true,
    }
  },
  methods: {
    changeTagName(newTagName) {
      this.$emit('changeTag', {tagId: this.tag.id, tagName: newTagName});
    },
  },
};
</script>

<style scoped lang="scss">
.tag {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .tag-name {
    display: flex;
    align-items: center;
    gap: 10px;
    width: fit-content;

    & > :not(:first-child) {
      pointer-events: none;
      opacity: 0.4;
    }
  }

  .name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 250px;

    .name-wrapper {
      display: flex;
      align-items: center;
      overflow-x: hidden;

      .info .info-name {
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 180px;
      }
    }

    .no-name {
      width: 100%;
      min-width: 220px;
    }
  }

  svg {
    cursor: grab;
  }
}
</style>
